import { useListAutomaticSharings } from '@modusign/openapi-client-user';

import { adaptResourceRoleSubject } from '@app/features/workspaceManagement/types';
import { useWorkspaceId } from '@app/hooks/useWorkspaceId';

export default function useGetUserAutoSharingTargets({ memberId }: { memberId: string }) {
  const workspaceId = useWorkspaceId();

  return useListAutomaticSharings(
    workspaceId,
    {
      memberIds: [memberId],
    },
    {
      query: {
        select: ({ automaticSharings }) => {
          return (
            automaticSharings
              .find((as) => as.memberId === memberId)
              ?.targets.map(adaptResourceRoleSubject) || []
          );
        },
        refetchOnWindowFocus: false,
        enabled: !!memberId,
        staleTime: 1000,
      },
    }
  );
}
